
export const lazyloadInit = () => {
    let spinner = document.querySelector(".posts__spinner");
    let allChunks = document.querySelectorAll('.posts > .container .posts__chunk');
    let displayedChunks = 1; // Start with 1 because the first chunk is initially displayed
    
    document.addEventListener("scroll", async function() {
        var container = document.querySelector('.posts > .container');
        if (window.innerHeight + window.scrollY >= container.offsetHeight + container.offsetTop) {
            if (displayedChunks < allChunks.length) { // Check if more chunks are available
                spinner.style.opacity = 1;
                await new Promise(r => setTimeout(r, 1000));
                spinner.style.opacity = 0;
                showNextChunk();
            }
        }
    });
    
    function showNextChunk() {
        var nextChunk = document.querySelector('.posts > .container .posts__chunk:not([style*="display: none"]) + .posts__chunk');
        if (nextChunk) {
            nextChunk.style.display = 'block';
            displayedChunks++; // Increment the count of displayed chunks
        }
    }
    

 }
 